// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cu-AZ","choices":"styles_choices__cXnpP","title":"styles_title__nFTLv","btns":"styles_btns__5X-QP"};